import type { TOC } from '@ember/component/template-only'
import { TeacherToolkitCategoryBlock } from 'teacher-ui-client/components/teacher-toolkit/category-block'
import type { TeacherResourceCategoryEntry } from 'teacher-ui-client/contentful-client/entry-types'

interface Args {
  categories: TeacherResourceCategoryEntry[]
}
interface Signature {
  Args: Args
  Element: HTMLUListElement
}
export const TeacherToolkitCategoriesList: TOC<Signature> = <template>
  <ul ...attributes>
    {{#each @categories as |category|}}
      <li><TeacherToolkitCategoryBlock @category={{category}} /></li>
    {{/each}}
  </ul>
</template>

export default TeacherToolkitCategoriesList
